import React, { useState } from "react";
import DataTable from "../ui/DataTable";
import { FaEdit, FaTrash } from "react-icons/fa";
import PropTypes from "prop-types";

const DistrictTable = ({ data = [], onEdit, onDelete, pageSize = 10 }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const options = { year: "numeric", month: "short", day: "numeric" };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const columns = [
        {
            key: "serial",
            label: "SL No",
            sortable: false,
            render: (_, __, index) =>
                (currentPage - 1) * pageSize + index + 1
        },
        { key: "stateCode", label: "State Code" },
        { key: "name", label: "District Name" },
        {
            key: "createdAt",
            label: "Created At",
            render: (value) => formatDate(value)
        }
    ];

    const actions = [
        {
            label: "Edit",
            icon: <FaEdit />,
            variant: "warning",
            onClick: (item) => onEdit(item),
            tooltip: "Edit district"
        },
        {
            label: "Delete",
            icon: <FaTrash />,
            variant: "danger",
            onClick: (item) => onDelete(item),
            tooltip: "Delete district"
        }
    ];

    return (
        <DataTable
            columns={columns}
            data={data}
            actions={actions}
            searchable
            searchTerm={searchTerm}
            onSearchChange={setSearchTerm}
            pagination
            pageSize={pageSize}
            striped
            hover
            bordered
            responsive
            className="mt-3"
            onPageChange={setCurrentPage}
        />
    );
};

DistrictTable.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            _id: PropTypes.string.isRequired,
            stateCode: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            createdAt: PropTypes.string
        })
    ),
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    pageSize: PropTypes.number
};

DistrictTable.defaultProps = {
    pageSize: 10
};

export default DistrictTable;
